
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.712 1.212a.938.938 0 011.338 1.313L5.062 8.762a.938.938 0 01-1.35.025L.405 5.48A.938.938 0 111.73 4.155l2.617 2.616L8.69 1.24a.334.334 0 01.025-.028h-.002z","fill":"#27AE60"}})])
          )
        }
      }
    